// Talks to the AssistantBot SUNAT browser extension (see extension/), which logs into SOL and opens
// a message in the Buzón Electrónico. Chrome only exposes chrome.runtime.sendMessage to this page
// when an installed extension lists our origin in its externally_connectable manifest key.

export const SUNAT_EXTENSION_ID = import.meta.env.VITE_SUNAT_EXTENSION_ID;
export const SUNAT_EXTENSION_URL = import.meta.env.VITE_SUNAT_EXTENSION_URL;

export class SunatExtensionError extends Error {
    constructor(code) {
        super(code);
        this.code = code;
    }
}

function sendToExtension(message, timeoutMs) {
    return new Promise((resolve, reject) => {
        const runtime = window.chrome?.runtime;
        if (!SUNAT_EXTENSION_ID || !runtime?.sendMessage) {
            reject(new SunatExtensionError('extensionMissing'));
            return;
        }
        const timer = setTimeout(() => reject(new SunatExtensionError('extensionMissing')), timeoutMs);
        runtime.sendMessage(SUNAT_EXTENSION_ID, message, (response) => {
            clearTimeout(timer);
            // Set when no extension with that ID is installed or enabled.
            if (runtime.lastError || !response) {
                reject(new SunatExtensionError('extensionMissing'));
            } else {
                resolve(response);
            }
        });
    });
}

export async function assertExtensionInstalled() {
    await sendToExtension({ type: 'PING' }, 1000);
}

// Resolves once the extension has redeemed the token and opened the SUNAT window.
export async function openMessageInSunat(token) {
    const response = await sendToExtension({ type: 'OPEN_MESSAGE', token }, 30000);
    if (!response.ok) {
        throw new SunatExtensionError(response.error ?? 'openFailed');
    }
}